module.exports = __webpack_public_path__ + "static/media/melissa2.762c9499.jpg";